import React from 'react'
import { getFileExtension, getImageNameFromUrl } from 'utils/utils'
import { VscFilePdf, VscFileZip } from 'react-icons/vsc'
import {
    BsFiletypeCsv,
    BsFiletypeDoc,
    BsFiletypeDocx,
    BsFiletypeXls,
    BsFiletypeXlsx,
} from 'react-icons/bs'

const RenderThumbnail = ({ name, url, type, file }) => {
    const FileIcon = ({ children }) => {
        return <span className="text-4xl">{children}</span>
    }

    let fileName = name
    let fileExtension = ''

    if (url) {
        fileName = getImageNameFromUrl(url)
        fileExtension = getFileExtension(fileName)
    } else if (type) {
        const possibleExtension = type.split('/')[1]
        fileExtension = possibleExtension ? possibleExtension.toLowerCase() : ''
    }

    const isImageFile =
        type?.split('/')[0] === 'image' ||
        ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)

    if (isImageFile) {
        return (
            <img
                className="upload-file-image"
                src={url || URL.createObjectURL(file)}
                alt={`file preview ${fileName}`}
            />
        )
    }

    if (fileExtension === 'zip' || type === 'application/zip') {
        return (
            <FileIcon>
                <VscFileZip />
            </FileIcon>
        )
    }

    if (fileExtension === 'pdf' || type === 'application/pdf') {
        return (
            <FileIcon>
                <VscFilePdf />
            </FileIcon>
        )
    }

    if (
        fileExtension === 'doc' ||
        fileExtension === 'docx' ||
        type === 'application/msword' ||
        type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) {
        return (
            <FileIcon>
                {fileExtension === 'docx' ? (
                    <BsFiletypeDocx />
                ) : (
                    <BsFiletypeDoc />
                )}
            </FileIcon>
        )
    }

    if (
        fileExtension === 'xls' ||
        fileExtension === 'xlsx' ||
        fileExtension === 'csv' ||
        type === 'application/vnd.ms-excel' ||
        type ===
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        type === 'text/csv'
    ) {
        return (
            <FileIcon>
                {fileExtension === 'xlsx' ? (
                    <BsFiletypeXlsx />
                ) : fileExtension === 'csv' ? (
                    <BsFiletypeCsv />
                ) : (
                    <BsFiletypeXls />
                )}
            </FileIcon>
        )
    }

    return (
        <FileIcon>
            <VscFileZip />
        </FileIcon>
    )
}

export default RenderThumbnail
